import { ACCOUNT_API, AccountGetResponse } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { GetAccountError, GetAccountVariables, fetchGetAccount } from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = ACCOUNT_API.GET;

export const useGetAccount = (
  variables: GetAccountVariables,
  opts?: Omit<UseQueryOptions<AccountGetResponse, GetAccountError>, 'queryKey' | 'queryFn'>,
): UseQueryResult<AccountGetResponse, GetAccountError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<AccountGetResponse, GetAccountError>({
    queryKey: queryKeyFn({
      path: '/api/v1/account',
      operationId: 'getAccount',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetAccount({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
